// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H7Hq","icon":"styles_icon__1rsve"};